<div class="md:m-1">
  <p-tabs value="0">
    <p-tablist>
      <p-tab value="0"><i class="pi pi-chart-bar mr-3"></i>Dashboard</p-tab>
      @if (
        !energyMeterService.isLoadingList() &&
        !emsService.isLoading() &&
        !bmsService.isLoading() &&
        !inverterService.isLoading()
      ) {
        <p-tab value="2"
          ><i class="fa-solid fa-clock-rotate-left mr-3"></i>History</p-tab
        >
        @if (showAdminFields) {
          <p-tab value="3"><i class="fa-solid fa-toolbox mr-3"></i>Tools</p-tab>
        }
      }
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <div class="grid grid-cols-12 gap-4 m-0">
          <p class="col-span-12 md:col-span-6 lg:col-span-8 2xl:col-span-9">
            @if (
              energyMeterService.energyMeters().length > 0 &&
              !energyMeterService.isLoadingList() &&
              !energyMeterService.isLoadingLog()
            ) {
              <app-energy-meter-view
                [energyMeterList]="energyMeterService.energyMeters()"
                [energyMeterLogInfo]="energyMeterService.energyMeterLog()"
              />
            } @else if (energyMeterService.energyMeters().length === 0) {
              There are currently no meters found. If you're sure there should
              be meters on this dashboard, please let us know!
            } @else if (energyMeterService.isLoadingList()) {
              Loading meters!
            }
          </p>
          <p class="col-span-12 md:col-span-6 lg:col-span-4 2xl:col-span-3">
            @if (
              !controllerService.isLoading() &&
              controllerService.controllerRequired() !== null &&
              hasPermission(permissions.see_controller_info)
            ) {
              <app-controller-table
                [controller]="controllerService.controllerRequired()!"
                [isLoading]="controllerService.isLoading()"
              />
            }
          </p>

          <p class="col-span-12">
            @if (
              !inverterService.isLoading() &&
              inverterService.inverters().length > 0 &&
              hasPermission(permissions.see_inverter_info)
            ) {
              <app-inverter-table
                [inverterList]="inverterService.inverters()"
                [isLoading]="inverterService.isLoading()"
              />
            }
          </p>
          <p class="col-span-12">
            @if (
              !energyMeterService.isLoadingList() &&
              energyMeterService.energyMeters().length > 0 &&
              hasPermission(permissions.see_energy_meter_info)
            ) {
              <app-energy-meter-table
                [energyMeterList]="energyMeterService.energyMeters()"
                [isLoading]="energyMeterService.isLoadingList()"
              />
            }
          </p>
          @if (
            !emsService.isLoading() &&
            emsService.emsList().length > 0 &&
            hasPermission(permissions.see_ems_info)
          ) {
            <p class="col-span-12">
              <app-ems-table
                [EMSList]="emsService.emsList()"
                [isLoading]="emsService.isLoading()"
              />
            </p>
          }
          @if (
            !bmsService.isLoading() &&
            bmsService.bmsList().length > 0 &&
            hasPermission(permissions.see_bms_info)
          ) {
            <p class="col-span-12">
              <app-bms-table
                [BMSList]="bmsService.bmsList()"
                [isLoading]="bmsService.isLoading()"
              />
            </p>
          }
          @if (
            !ioService.isLoading() &&
            ioService.ioInformation() &&
            controllerService.controllerRequired() &&
            hasPermission(permissions.see_io_info)
          ) {
            @if (ioService.ioInformation()!.amountOfOutputs > 0) {
              <p class="col-span-12">
                <app-d-outputs-table
                  [ioInformation]="ioService.ioRequired()"
                  [isLoading]="ioService.isLoading()"
                />
              </p>
            }
            @if (ioService.ioInformation()!.amountOfInputs > 0) {
              <p class="col-span-12">
                <app-d-inputs-table
                  [ioInformation]="ioService.ioRequired()"
                  [isLoading]="ioService.isLoading()"
                />
              </p>
            }
          }

          @if (
            (!extIOService.isLoading() &&
              extIOService.normalIOExtendersRequired() !== null) ||
            extIOService.gen2IOExtendersRequired() !== null ||
            extIOService.analogIOExtendersRequired() !== null
          ) {
            <p class="col-span-12">
              <app-io-addon-view
                [normalExtenders]="extIOService.normalIOExtendersRequired()!"
                [analogExtenders]="extIOService.analogIOExtendersRequired()!"
                [gen2Extenders]="extIOService.gen2IOExtendersRequired()!"
                [isLoading]="extIOService.isLoading()"
              />
            </p>
          }
        </div>
      </p-tabpanel>
      @if (
        !energyMeterService.isLoadingList() &&
        !emsService.isLoading() &&
        !bmsService.isLoading() &&
        !inverterService.isLoading() &&
        controllerService.controllerRequired() &&
        hasPermission(permissions.see_history_info)
      ) {
        <p-tabpanel value="2">
          <div class="grid grid-cols-12 gap-4 m-0">
            <p class="col-span-12">
              <app-history
                [energyMeters]="energyMeterService.energyMeters()"
                [batterySystems]="emsService.emsList()"
                [bmsSystems]="bmsService.bmsList()"
                [inverterSystems]="inverterService.inverters()"
                [savingVoltagesHistory]="
                  controllerService.controllerRequired()!.savingVoltageHistory
                "
                [gridImportLimitKW]="
                  controllerService.controllerRequired()!.gridImportLimit
                "
                [gridExportLimitKW]="
                  controllerService.controllerRequired()!.gridExportLimit
                "
              />
            </p>
          </div>
        </p-tabpanel>
        @if (showAdminFields && !controllerService.isLoading()) {
          <p-tabpanel value="3">
            <div class="grid grid-cols-12 gap-4 m-0">
              <p class="col-span-12">
                <app-tools
                  [controller]="controllerService.controllerRequired()!"
                />
              </p>
            </div>
          </p-tabpanel>
        }
      }
    </p-tabpanels>
  </p-tabs>
</div>
